export default __webpack_public_path__ + "static/media/logo-tilted-small.211b1147.png";